import { render, staticRenderFns } from "./lk-video.vue?vue&type=template&id=573e3156&"
import script from "./lk-video.vue?vue&type=script&lang=js&"
export * from "./lk-video.vue?vue&type=script&lang=js&"
import style0 from "./lk-video.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-video/lk-video.vue
// module id = 569
// module chunks = 0